export const defaultWorkStartTime = '08:00';
